/**
 * Supposed to be triggered right before a request is sent
 */
import AuthService from '../../services/auth.service';
import { DEFAULT_LOCALE } from '../constants';

const authService = new AuthService();

export default (config = {}) => {
  const newConfig = { ...config };
  if (!newConfig.headers) {
    newConfig.headers = {};
  }
  const authToken = newConfig.headers.authorization || authService.getToken() || '';

  newConfig.headers.authorization = authToken;
  newConfig.headers.selectedLanguage = localStorage.getItem("language") || DEFAULT_LOCALE;

  return newConfig;
};
